<template>
    <div id="availableAssetList">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
            <div class="admin-page-content asset-availability">
                <div class="btn-groups text-right">
                    <a v-if="hideButton === false" href="javascript:void(0)" v-on:click="makeReservationNew" class='btn btn-primary' style="" >
                        <i class="fp-calendar"> </i> Add Reservation
                    </a>
                </div>
                <data-table-filter-config :moduleName="'availableAssetList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                <section class="bg-white data-table">
                    <custom-pagination
                        :page-changed="onPageChange"
                        :per-page-changed="onPerPageChange" :moduleName="'availableAssetList'" :position="'top'">
                    </custom-pagination>

                    <vue-good-table
                        ref="listVehicleTable"
                        mode="remote"
                        title="Asset"
                        @on-page-change="onPageChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-selected-rows-change="selectionChanged"
                        @on-sort-change="onSortChange"
                        :totalRows="totalRecords"
                        :columns="userColumns"
                        :rows="rows"
                        :pagination-options="{
                            enabled: false,
                            position: 'both',
                            setCurrentPage:listCurrentPage,
                            perPage: perPage,
                            perPageDropdown:dropDownPerPage,
                            dropdownAllowAll: false,
                        }"
                        :select-options="{
                        enabled: searchAsset,
                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                        selectionInfoClass: 'custom-class',
                        selectionText: 'rows selected',
                        clearSelectionText: 'clear',
                        }"
                            :search-options="{
                        enabled: false,
                        }">
                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                            <div :key="key">
                                <div v-if="props.column.field == 'unit_no' && canViewAsset">
                                    <router-link class="color-blue"  title="View Asset Details" v-bind:to="{name: 'AssetView',params:{id:props.row.id}}">
                                        {{props.row.unit_no}}
                                    </router-link>
                                </div>
                                <div v-else>
                                    {{props.formattedRow[props.column.field]}}
                                </div>
                            </div>
                        </template>
                        <div slot="selected-row-actions">
                            <button  v-if="canMakeReservation && hideButton===false" id="make_reservation" class="btn btn-primary" v-on:click.prevent="makeReservation()">Add Reservation</button>
                        </div>
                        <div slot="emptystate">
                            <div style='text-align: center'>
                                Sorry, currently no asset is available
                            </div>
                        </div>
                    </vue-good-table>
                    <custom-pagination
                        :page-changed="onPageChange"
                        :per-page-changed="onPerPageChange">
                    </custom-pagination>
                </section>
            </div>
    </div>
</template>
<script>

    import EventBus from "./event-bus";
    import Vue from "vue";

    
    



    import {commonMixins} from '../mixins/commonMixins';
    import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "VehicleList",
        mixins:[commonMixins,dataTableMixins],
        props: {
            assetAvailabilityVal: {
                type: Array,
                required: true,
                default:undefined
            },
            reportVal:{
                type: String,
                required: false,
                default:undefined
            }
        },
        data: () => ({
            availabilityFromDate:null,
            availabilityToDate:null,
            availabilityLocation:"",
            availabilityAssetType:"",
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Unit',
                    field: 'unit_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit No.", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Name',
                    field: 'name',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Vin',
                    field: 'vin',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "VIN", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Status',
                    field: 'status',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterDropdownItems: [],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Asset Type',
                    field: 'asset_type',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Asset Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Assigned Facility',
                    field: 'location',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Facility", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Physicall Location',
                    field: 'physical_location',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Physical Location", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                // {
                //     label: 'Odometer Reading',
                //     field: 'odometer_reading',
                //     filterable: true,
                //     filterOptions: {
                //         enabled: true, // enable filter for this column
                //         placeholder: "Reading", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                // {
                //     label: 'Reading Updated At',
                //     field: 'odometer_reading_time',
                //     filterable: true,
                //     filterOptions: {
                //         enabled: true, // enable filter for this column
                //         placeholder: "MM/DD/YYYY", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                {
                    label: 'Purchase Date',
                    field: 'purchase_date',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Date In Service',
                    field: 'date_in_service',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                // {
                //     label: 'Is Standard',
                //     field: 'is_standard_unit',
                //     filterable: true,
                //     filterOptions: {
                //         enabled: true, // enable filter for this column
                //         placeholder: "Select Is Standard", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         filterDropdownItems: ['YES', 'NO'],
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                // {
                //     label: 'Actions',
                //     field: 'action',
                //     sortable: false,
                // },
                {
                    label: 'Available On',
                    field: 'available_on',
                    fpFieldType:"custom_asset_availability",
                    hidden: true,
                    sortable: false,
                },
            ],
            rows: [],
            totalRecords: 0,
            asset_value: false,
            loading:false,
            accessAddAsset:false,
            accessCheckAvailability:false,
            loadAsset:'false',
            searchAsset:true,
            canMakeReservation:false,
            canViewAsset:false,
            getDataOf: '',
            pickupDate:"",
            dropoffDdate:"",
            hideButton: false

        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_asset') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_asset') {
                            self.asset_value = true;
                        }
                        if (permissions[i].name == 'add_asset') {
                            self.accessAddAsset = true;
                        }
                        if (permissions[i].name == 'check_asset_availability') {
                            self.accessCheckAvailability = true;
                        }
                        if (permissions[i].name == 'make_reservation') {
                            self.canMakeReservation = true;
                        }
                        if (permissions[i].name == 'view_asset') {
                            self.canViewAsset = true;
                        }
                    }
                }

            },
            '$route.path':function(val,oldval){
                var self = this;
                console.log(val);
                console.log(oldval);
                // this.mounted();

                setTimeout(function(){

                var page = self.$route.path.split('/');
                var type = '';
                console.log(page[2]);
                if (page && page[2] == 'lease'){
                    // self.title = 'Lease Reservation';
                    type = 'lease';
                }else{
                    // self.title = 'Rental Reservation';
                }
                // self.pasResVal = [self.type,"getpastreservation"];
                // self.curResVal = [self.type,"getcurrentreservation"];
                self.assetAvailabilityVal = [type,'getavailableasset'];
                // self.avaAssetVal = [self.type,'getavailableasset'];

                self.loadList();
                },100);
            },
        },
        created: function() {

        },

        mounted: function() {
            var self = this;

            if( self.assetAvailabilityVal != undefined && self.assetAvailabilityVal[1] && self.assetAvailabilityVal[1] == 'getavailableasset'){
                self.loadAsset = 'true';
                self.loadList();
            }
            if( self.reportVal != undefined ){
                self.loadAsset = 'true';
                self.hideButton = true;
                self.searchAsset = false;
                self.loadList();
            }

            this.$root.$on('load_availability', () => {

                self.loadAsset = 'true';
                self.loadList();
            });

            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listVehicleTable.unselectAllInternal();
            },

            loadList: function() {

                var self = this;
                var page = self.$route.path.split('/');
                var type = '';
               // console.log(page[2]);
                if (page && page[2] == 'lease'){
                    // self.title = 'Lease Reservation';
                    type = 'lease';
                }else{
                    // self.title = 'Rental Reservation';
                    type = '';
                }

                self.loading = true;
                self.getDataOf = "/get-units";
                 if(self.reportVal == 'availableEquipmentReport'){
                    self.flag='availableEquipmentReport'
                  }
                if(self.loadAsset == 'false'){
                    self.loading = false;
                    return;
                }

                //check filters set or not
                if ( self.$children ) {

                    for( var j=0; j<self.$children.length; j++ ) {

                        if ( self.$children[j].id == "dataTableFilterConfig" && self.$children[j].columnFilterArr ) {

                            var params = self.$children[j].columnFilterArr;
                            var result = Object.keys(params).map((key) => {
                                return params[key]
                            })
                            if ( result.length > 0 && result[0].columnId != undefined ) {

                                for ( var i = 0; i< result.length; i++ ) {
                                    if ( result[i].columnId.field == 'Available On') {
                                        self.pickupDate = result[i]['filterValue'][0];
                                        self.dropoffDdate = result[i]['filterValue'][1];
                                    }
                                }
                            }

                            break;
                        }
                    }
                }


                if (  self.assetAvailabilityVal != undefined && self.assetAvailabilityVal[1] && self.assetAvailabilityVal[1] == 'getavailableasset' ) {

                    //this.serverParams.columnFilters = params;
                    self.getDataOf = "/get-available-units";

                } else if(self.reportVal != undefined){

                  self.getDataOf = "/get-available-units";

                }else {
                    var location = localStorage.getItem('location');
                    var truckType = localStorage.getItem('truckType');
                    var pick_date = localStorage.getItem('pick_date');
                    var drop_date = localStorage.getItem('drop_date');

                }

                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    pick_date:pick_date,
                    drop_date:drop_date,
                    location_id:location,
                    type_id:truckType,
                    type:type,
                    flag:self.flag,

                };

                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + self.getDataOf,
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            // self.filteredFlag = false;
                            if( self.assetAvailabilityVal != undefined && self.assetAvailabilityVal[1] && self.assetAvailabilityVal[1] != 'getavailableasset'){
                                localStorage.removeItem('truckType');
                                localStorage.removeItem('pick_date');
                                localStorage.removeItem('drop_date');
                                localStorage.removeItem('customer_id');
                                localStorage.removeItem('location');
                                localStorage.removeItem('pickup_time');
                                localStorage.removeItem('drop_time');
                                localStorage.removeItem('miles');
                            }

                            if ( data.res_count){
                                EventBus.$emit("pendingReservationCount", data.res_count.pendingReservationCount);
                                EventBus.$emit("pastReservationCount", data.res_count.pastReservationCount);
                                EventBus.$emit("currentReservationCount", data.res_count.currentReservationCount);
                                EventBus.$emit('avelableunitCount',  data.res_count.avelableunitCount);
                                  
                            }

                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'available-rsvtn-list')
                    }
                });
            },
            loadAvailableAssetList: function(params) {
                var self = this;
                self.loading = true;
                // alert(params);
                if(params.length >= 1){
                    this.serverParams.columnFilters = params;
                }

                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,

                };
                // self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/get-available-units",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            // self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'available-rsvtn-asset-list')
                    }
                });
            },
            VehicleDelete() {

                var data = this.$refs['listVehicleTable'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listVehicleTable'].selectedRows[i].id)
                }

                if (confirm('Are you sure that you want to delete this Asset? ')) {
                    self.loading = true;
                    $("#deleteVehicleBtn").val("Deleting ...");
                    $.ajax({
                        url: process.env.ROOT_API + "/asset/delete",
                        type: "POST",
                        data: 'id=' + use,
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            setTimeout(function () {
                                $(".alert-success").removeClass("show");
                                $(".alert-success").addClass("hide");
                            }, 10000);
                            setTimeout(function () {
                                $("#deleteVehicleBtn").val("Delete");
                            }, 10000);
                            self.rows = data.content.row;
                            if (data.code == '200') {
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.loadList();
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'available-rsvtn-delete-asset')
                        }
                    });
                }
            },
            selectionChanged(param) {
                var self = this;
                var rowData = self.$refs['listVehicleTable'].selectedRows;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
            },
            syncAsset() {

                var self = this;
                self.loading = true;
                $("#syncAssetBtn").text("Syncing...");
                $("#syncAssetBtn").prop("disabled", true);

                $.ajax({
                    url: process.env.ROOT_API + "/sync-asset",
                    type: "GET",
                    // data: 'id=' + use,
                    headers: this.ajxHeaders,
                    dataType: 'json',
                    success: function (data) {

                        self.loading = false;
                        $("#syncAssetBtn").text("Sync");
                        $("#syncAssetBtn").prop("disabled", false);

                        if (data.status == 'success') {

                            self.$swal({
                                // title: data.content + " " ,
                                text: data.content + " Asset are Sync.",
                                type: "success",
                                confirmButtonText: "Confirm",
                            }).then(result => {
                                if (result.value) {
                                    self.loadList();
                                }
                            });
                        }
                    },
                    error: function (jqXHR, exception) {

                        self.loading = false;
                        $("#syncAssetBtn").text("Sync");
                        $("#syncAssetBtn").prop("disabled", false);
                        self.generateStatusCodeMessage(jqXHR,true,'available-rsvtn-sync-asset')
                    }
                });
            },
            makeReservation(){
                var self = this;
                var dataArr = self.$refs['listVehicleTable'].selectedRows;
                // console.log(dataArr);
                var assetType = "";
                var location = "";
                var units = "";
                for(var i = 0; i<dataArr.length; i++){
                    assetType = dataArr[0].asset_type;
                    location = dataArr[0].location;
                    console.log(dataArr[i]);
                    if(dataArr[i].asset_type != assetType || dataArr[i.location != location]){
                        self.$swal('','Please select asset with same type and location','info');
                        return;
                    }else{
                        if(units != ''){
                            units += ','+dataArr[i].unit_no;
                        }else{
                            units = dataArr[i].unit_no;
                        }
                    }
                }

                console.log('unit='+units);
                // return;
                var pickup_date = self.pickupDate;
                var dropoff_date = self.dropoffDdate;
                // EventBus.$emit("unit-data", unitArr);
                var string = "&for=availability"+"&location_id="+dataArr[0].location_id+"&location_name="+dataArr[0].location+"&pickup_date="+pickup_date+"&unit="+units+"&dropoff_date="+dropoff_date+"&asset_type_id="+dataArr[0].asset_type_id+"&location_code="+dataArr[0].location_code;
                self.$router.push({ name: 'MakeReservation', query: { data : btoa(string), asset_type : btoa(unescape(encodeURIComponent(dataArr[0].asset_type))) }})
            },
            makeReservationNew: function(){
                var page = this.$route.path.split('/');
                var type = '';
                console.log(page[2]);

                var string = "&from="+page[2];
                this.$router.push({ name: 'MakeReservation', query: { data : btoa(string) }});

            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/SearchAvailableAsset.vue